/* global angular Blob */

var moment = require('moment')
var Highcharts = require('highcharts/highstock')
var FileSaver = require('file-saver')
require('highcharts/modules/exporting.js')
var noData = require('highcharts/modules/no-data-to-display.js')

angular.module('AemCspsFunds')
  .component('fundDetail', {
    template: require('./fund-detail.component.tpl.html'),
    controller: FundDetailCtrl,
    controllerAs: 'vm'
  })

FundDetailCtrl.$inject = ['wgService', 'appLoader', 'pensionService', 'helper', '$filter', 'widgetParamsService', 'i18n']

function FundDetailCtrl (wgService, appLoader, pensionService, helper, $filter, widgetParamsService, i18n) {
  var vm = this
  noData(Highcharts)

  vm.$onInit = function () {
    vm.isErrorBackend = false
    vm.fundId = wgService.getParams().fundId || 'dps1'
    vm.fundData = []
    vm.csvexportData = []
    vm.onRangeChange = onRangeChange
    vm.chartDateFrom = null
    vm.chartDateTo = moment(new Date()).startOf('day').toDate()
    vm.downloadCsv = downloadCsv

    vm.ranges = [
      {
        value: 1,
        type: 'MONTHS'
      },
      {
        value: 6,
        type: 'MONTHS'
      },
      {
        value: 1,
        type: 'YEARS'
      },
      {
        value: 3,
        type: 'YEARS'
      },
      {
        value: 5,
        type: 'YEARS'
      },
      {
        value: 10,
        type: 'YEARS'
      },
      {
        type: 'ALL'
      },
      {
        type: 'FREE'
      }
    ]

    vm.selectedDropdownIndex = 2

    widgetParamsService.get('AemCspsFunds')
      .then(function (res) {
        if (res.data.dropdownRanges) {
          vm.ranges = res.data.dropdownRanges.options
          vm.selectedDropdownIndex = res.data.dropdownRanges.selectedIndex
        }
        return onRangeChange()
      })
      .catch(function () {
        vm.isErrorBackend = true
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function onRangeChange () {
    if (vm.ranges[vm.selectedDropdownIndex].type === 'FREE') {
    } else if (vm.ranges[vm.selectedDropdownIndex].type === 'ALL') {
      vm.chartDateFrom = null
      vm.chartDateTo = null
    } else {
      if (!vm.chartDateTo) {
        vm.chartDateTo = moment(new Date()).startOf('day').toDate()
      }
      vm.chartDateFrom = moment(vm.chartDateTo).subtract(vm.ranges[vm.selectedDropdownIndex].value, vm.ranges[vm.selectedDropdownIndex].type).startOf('day').toDate()
    }
    return getData(vm.chartDateFrom, vm.chartDateTo)
  }

  function getData (from, to) {
    var params = {
      from: from && moment(from).format('YYYY-MM-DD'),
      to: to && moment(to).format('YYYY-MM-DD')
    }
    appLoader.show()
    return pensionService.fundHistory(vm.fundId, params)
      .then(function (res) {
        vm.fundData = res.data.map(function (element) {
          return {
            x: moment(element.date).valueOf(),
            y: element.valorizationPercentage,
            value: element.value
          }
        }).sort(function (a, b) {
          return a.x - b.x
        })

        vm.csvexportData = res.data.map(function (element) {
          return {
            date: moment(element.date).valueOf(),
            unitCount: element.unitCount,
            increase: element.increase,
            value: element.value,
            valorizationPercentage: element.valorizationPercentage
          }
        }).sort(function (a, b) {
          return b.date - a.date
        })

        if (!from && res.data.length) {
          vm.chartDateFrom = moment(res.data[0].date).startOf('day').toDate()
        }
        if (!to && res.data.length) {
          vm.chartDateTo = moment(res.data[res.data.length - 1].date).startOf('day').toDate()
        }

        generateHighchart(vm.fundData)
      })
      .catch(function () {
        vm.isErrorBackend = true
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function generateHighchart (data) {
    var lang = angular.extend({}, helper.chartLocal(), {
      noData: $filter('translate')('NODATA')
    })

    Highcharts.chart('chart1', {
      lang: lang,
      navigator: {
        enabled: false
      },
      noData: {
        style: {
          fontFamily: '"Open Sans", sans-serif',
          fontSize: '16px',
          fontWeight: '400',
          color: '#303A45'
        }
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          second: '%d. %m. %Y<br/>%k:%M:%S',
          minute: '%d. %m. %Y<br/>%k:%M',
          hour: '%d. %m. %Y<br/>%k:%M',
          day: '%d. %m.',
          week: '%d. %m.',
          month: '%d. %m.<br/>%Y',
          year: '%Y'
        },
        labels: {
          align: 'center',
          useHTML: false,
          y: 30
        }
      },

      yAxis: {
        allowDecimals: true,
        title: {
          text: false
        },
        labels: {
          format: '{value} %'
        }
      },

      global: {
        useUTC: true
      },

      title: {
        text: false
      },

      legend: {
        enabled: false
      },

      tooltip: {
        formatter: function () {
          return $filter('date')(this.x, 'd. M. yyyy') + '<br /><span style="color:' + this.point.color + '">\u25CF </span> <strong>' + $filter('currency')(this.y, '', 2) + '%</strong><br /><strong>' + $filter('currency')(this.point.value, '', 4) + $filter('translate')('CZK') + '</strong>'
        }
      },

      credits: {
        enabled: false
      },

      exporting: { enabled: false },

      series: [{
        data: data
      }]
    })
  }

  function downloadCsv () {
    if (!vm.csvexportData) {
      return
    }
    var data = [
      getCsvHeader(),
      vm.csvexportData.map(function (item) {
        return [
          formatCsvDate(item.date),
          formatCsvNumber(item.unitCount),
          formatCsvNumber(item.value),
          formatCsvNumber(item.valorizationPercentage),
          formatCsvNumber(item.increase)
        ].join(';')
      }).join('\n')
    ].join('\n')

    var blob = new Blob([data], { type: 'text/plain;charset=utf-8' })
    var fundName = $filter('translate')('FUND_NAME_' + vm.fundId.toUpperCase())
    FileSaver.saveAs(blob, 'ČSPS - ' + fundName + '.csv')
  }

  function getCsvHeader () {
    return [
      $filter('translate')('DATE'),
      $filter('translate')('FOND_UNIT_COUNT'),
      $filter('translate')('FOND_UNIT_VALUE'),
      $filter('translate')('VALORIZATION_PERCENTAGE'),
      $filter('translate')('INCREASE')
    ].join(';')
  }

  function formatCsvNumber (value) {
    return (i18n.langCode === 'cs') ? value.toString().replace('.', ',') : value.toString()
  }

  function formatCsvDate (value) {
    return moment(value).format('YYYY-MM-DD')
  }
}
